import { render, staticRenderFns } from "./GenericField.vue?vue&type=template&id=b2daf52c&scoped=true&"
import script from "./GenericField.vue?vue&type=script&lang=js&"
export * from "./GenericField.vue?vue&type=script&lang=js&"
import style0 from "./GenericField.vue?vue&type=style&index=0&id=b2daf52c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2daf52c",
  null
  
)

export default component.exports